var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8861 12.1895L11.569 15.8976C11.3627 15.9599 11.1819 16.0871 11.0534 16.2605C10.9249 16.4339 10.8555 16.6443 10.8555 16.8603V31.6438C10.8555 33.5607 11.6327 35.5373 13.1639 37.4946C13.9971 38.5424 14.9311 39.5055 15.9522 40.37L19.35 33.3797C18.0176 32.2411 17.0395 30.7423 16.5323 29.062C16.0252 27.3816 16.0102 25.5905 16.4893 23.9019C16.9684 22.2132 17.9214 20.6983 19.2347 19.5375C20.5479 18.3767 22.1662 17.6189 23.8968 17.3545L23.8861 12.1895ZM18.7894 42.5403C20.7129 43.8599 22.7398 45.0209 24.8503 46.012C24.9789 46.0697 25.1182 46.0994 25.2591 46.0994C25.4 46.0994 25.5393 46.0697 25.6679 46.012C27.7916 45.0177 29.8308 43.8509 31.7649 42.5233L28.1547 35.1347C26.2957 35.7467 24.2904 35.7467 22.4315 35.1347L18.7894 42.5403ZM34.619 40.3189L31.2212 33.3797C32.5574 32.2379 33.5371 30.734 34.0431 29.0481C34.549 27.3622 34.5597 25.5658 34.0739 23.8739C33.5881 22.1821 32.6264 20.6666 31.3039 19.5088C29.9814 18.351 28.3542 17.6001 26.6172 17.3459V12.1916L38.9343 15.8976C39.1408 15.9596 39.3218 16.0868 39.4503 16.2602C39.5789 16.4337 39.6482 16.6442 39.6478 16.8603V31.6438C39.6478 33.5607 38.8727 35.5373 37.3416 37.4946C36.526 38.521 35.6143 39.4667 34.619 40.3189V40.3189Z",
    fill: "url(#paint0_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6251 32.2763C31.0506 31.2101 32.0336 29.6538 32.3858 27.9057H30.5383C30.249 28.963 29.647 29.9076 28.8118 30.615L25.2738 23.318L21.7528 30.5148C21.1241 29.9554 20.6343 29.2565 20.3224 28.4737C20.0106 27.691 19.8853 26.846 19.9565 26.0061C20.0277 25.1661 20.2935 24.3545 20.7327 23.6358C21.1719 22.9171 21.7723 22.3112 22.4862 21.8663C23.2 21.4213 24.0076 21.1498 24.8446 21.0731C25.6816 20.9965 26.5249 21.1169 27.3073 21.4248C28.0897 21.7327 28.7896 22.2196 29.3512 22.8467C29.9129 23.4738 30.3208 24.2237 30.5425 25.0368H32.3901C32.1573 23.8979 31.6534 22.8324 30.9214 21.931C30.1894 21.0296 29.2509 20.319 28.186 19.8598C27.1211 19.4007 25.9613 19.2065 24.8054 19.2939C23.6496 19.3813 22.5319 19.7476 21.5476 20.3617C20.5634 20.9758 19.7418 21.8195 19.1528 22.8207C18.5638 23.822 18.2249 24.9513 18.1649 26.1123C18.105 27.2733 18.3258 28.4316 18.8085 29.4886C19.2912 30.5455 20.0216 31.4698 20.9373 32.1825L16.6772 40.9002L18.1532 42.029L22.4323 33.0835C23.3346 33.4834 24.3093 33.6929 25.2957 33.6987C26.2822 33.7046 27.2592 33.5068 28.1662 33.1176L32.4623 41.9651L33.8193 40.9278L29.6251 32.2763ZM27.3974 31.4861L25.2738 27.1283L23.2075 31.4499C23.8666 31.7346 24.5758 31.8844 25.2935 31.8906C26.0111 31.8968 26.7228 31.7593 27.3868 31.4861H27.3974Z",
    fill: "url(#paint1_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2973 4.72409L39.7685 5.79968L39.9299 5.87849L42.1427 6.97538L42.3041 7.05418L42.8329 5.97007L42.0917 5.60373L41.0405 5.08191L40.2973 4.72409ZM43.3893 4.26617L42.2637 5.43547L41.0809 4.84976L41.3251 3.2353L44.1984 0.00640297L43.3893 4.26617ZM20.3605 51.7753L20.1014 51.6454L17.9778 50.5954L17.7187 50.4676L17.2939 51.3089L17.6252 51.4729C17.5168 51.7329 17.5114 52.0246 17.6099 52.2886C17.7085 52.5525 17.9037 52.7688 18.1558 52.8935C18.4078 53.0181 18.6978 53.0417 18.9665 52.9594C19.2353 52.8771 19.4627 52.6951 19.6023 52.4505L19.9358 52.6166L20.3605 51.7753Z",
    fill: "url(#paint2_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0366 5.8314C48.9063 7.06862 49.4272 8.51814 49.5445 10.0273C49.6618 11.5365 49.3711 13.0495 48.7031 14.4069C48.035 15.7643 47.0144 16.9159 45.7486 17.7405C44.4829 18.565 43.0188 19.0319 41.5107 19.0921C41.3398 19.3974 41.1361 19.6831 40.9033 19.944C41.6993 19.9819 42.4967 19.9153 43.2754 19.7459L43.5027 19.2795L44.0081 19.5521C44.3187 19.4573 44.6242 19.3464 44.9234 19.2198L44.8002 18.8705L45.1761 19.107C47.078 18.2254 48.6213 16.7167 49.5488 14.8324C50.4762 12.948 50.7317 10.8019 50.2728 8.75147L49.8481 8.59599L50.1985 8.48098C50.1178 8.16374 50.0207 7.85093 49.9076 7.54383L49.383 7.30954L49.6124 6.8431C49.2756 6.12075 48.8473 5.44497 48.3382 4.83249C48.2748 5.17562 48.1737 5.51064 48.0366 5.8314V5.8314Z",
    fill: "url(#paint3_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8672 6.18304C48.6592 7.36226 49.1266 8.73035 49.2221 10.1489C49.3176 11.5674 49.0378 12.9861 48.4111 14.2614C47.7844 15.5367 46.8329 16.6234 45.653 17.4114C44.4731 18.1995 43.1066 18.661 41.6917 18.7494C42.2018 17.6503 42.28 16.3988 41.9108 15.2445C41.5416 14.0902 40.7521 13.1179 39.6997 12.5216L41.7278 8.40451C42.8421 8.8773 44.0931 8.91118 45.2312 8.49939C46.3693 8.08759 47.3106 7.26042 47.8672 6.18304V6.18304Z",
    fill: "url(#paint4_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0188 7.22648L39.8039 6.13172L36.5611 12.7216L36.5059 12.8472L38.8971 13.5671L42.0188 7.22648Z",
    fill: "url(#paint5_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1289 50.2889L20.2525 51.3389L22.149 47.4881L20.1018 46.2847L18.1289 50.2889Z",
    fill: "url(#paint6_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1957 4.72408L10.7245 5.79967L10.5652 5.87847L8.35027 6.97536L8.18887 7.05417L7.66433 5.97006L8.40761 5.60372L9.46943 5.0819L10.1957 4.72408ZM7.10794 4.26615L8.23772 5.44185L9.42059 4.85613L9.17849 3.24168L6.29883 0.00638962L7.10794 4.26615ZM30.1367 51.7753L30.3958 51.6454L32.5195 50.5954L32.7807 50.4676L33.1948 51.3089L32.8614 51.4729C32.9698 51.7329 32.9752 52.0246 32.8767 52.2886C32.7781 52.5525 32.5829 52.7688 32.3309 52.8935C32.0788 53.0181 31.7889 53.0417 31.5201 52.9593C31.2513 52.877 31.0239 52.6951 30.8843 52.4505L30.553 52.6166L30.1367 51.7753Z",
    fill: "url(#paint7_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46015 5.8314C1.59049 7.06862 1.06958 8.51815 0.9523 10.0273C0.835016 11.5365 1.12569 13.0495 1.79372 14.4069C2.46174 15.7643 3.48239 16.9159 4.74816 17.7405C6.01393 18.565 7.47798 19.0319 8.98611 19.0921C9.15773 19.3974 9.36211 19.6831 9.5956 19.944C8.79966 19.9821 8.00219 19.9155 7.22349 19.7459L6.99413 19.2795L6.48871 19.5521C6.1788 19.4573 5.874 19.3463 5.57554 19.2198L5.69659 18.8705L5.32283 19.107C3.41753 18.2259 1.8717 16.7153 0.943939 14.828C0.0161776 12.9406 -0.23724 10.791 0.226079 8.73869L0.650808 8.58321L0.300407 8.4682C0.382021 8.15308 0.479839 7.84242 0.593469 7.53744L1.11589 7.30315L0.875914 6.8431C1.2127 6.12075 1.64096 5.44497 2.1501 4.83249C2.2172 5.17571 2.32116 5.51063 2.46015 5.8314V5.8314Z",
    fill: "url(#paint8_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.628 6.18308C1.83604 7.3623 1.36867 8.73039 1.27317 10.1489C1.17767 11.5675 1.45744 12.9862 2.08416 14.2614C2.71089 15.5367 3.66233 16.6234 4.84225 17.4115C6.02216 18.1995 7.38868 18.6611 8.80356 18.7494C8.29448 17.6502 8.21677 16.3991 8.5859 15.245C8.95502 14.091 9.74392 13.1187 10.7955 12.5216L8.76958 8.40455C7.65501 8.87745 6.40362 8.91139 5.26519 8.49961C4.12676 8.08783 3.18504 7.26062 2.628 6.18308Z",
    fill: "url(#paint9_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47949 7.22648L10.6923 6.13172L13.9373 12.7216L13.9903 12.8472L11.5991 13.5671L8.47949 7.22648Z",
    fill: "url(#paint10_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3662 50.2889L30.2426 51.3389L28.3462 47.4881L30.3934 46.2847L32.3662 50.2889Z",
    fill: "url(#paint11_linear_655_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7173 10.3957L39.8863 14.6555C40.2214 14.7566 40.515 14.9633 40.7239 15.2448C40.9327 15.5264 41.0456 15.8679 41.0458 16.2188V31.8522C41.0458 34.046 40.1602 36.2483 38.4847 38.3888L38.0366 38.0374C39.6548 35.965 40.4767 33.8841 40.4767 31.8607V16.2231C40.4754 15.994 40.4006 15.7715 40.2633 15.5885C40.1259 15.4055 39.9334 15.2717 39.7143 15.2071L25.5432 10.9474C25.3451 10.8881 25.134 10.8881 24.9358 10.9474L10.7669 15.2071C10.5493 15.2733 10.3587 15.4076 10.223 15.5905C10.0873 15.7734 10.0137 15.9951 10.013 16.2231V31.8564C10.013 33.8884 10.8327 35.9692 12.4509 38.0331C13.689 39.6156 15.3985 41.2045 17.5349 42.7551C19.8221 44.4018 22.2571 45.8314 24.8084 47.0255C24.9442 47.0872 25.0915 47.1191 25.2406 47.1191C25.3896 47.1191 25.537 47.0872 25.6727 47.0255C28.2238 45.8309 30.6588 44.4013 32.9462 42.7551C35.0826 41.2045 36.7921 39.6156 38.0281 38.0331L38.4762 38.3845C37.202 40.0203 35.4458 41.6454 33.2796 43.2172C30.9628 44.8895 28.4958 46.342 25.9106 47.5558C25.7012 47.6499 25.4743 47.6985 25.2448 47.6985C25.0154 47.6985 24.7885 47.6499 24.5791 47.5558C21.9923 46.3445 19.5232 44.8949 17.2036 43.2258C15.0354 41.6539 13.2834 40.0309 12.005 38.3931C10.3315 36.2632 9.44385 34.0502 9.44385 31.8564V16.2231C9.4448 15.8699 9.56001 15.5266 9.77216 15.2447C9.98431 14.9628 10.2819 14.7575 10.6203 14.6598L24.7893 10.4C25.0917 10.3087 25.4141 10.3072 25.7173 10.3957V10.3957Z",
    fill: "url(#paint12_linear_655_1649)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_1649",
    x1: 18.1757,
    y1: 11.7167,
    x2: 35.2214,
    y2: 43.7726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_655_1649",
    x1: 19.9392,
    y1: 19.9144,
    x2: 28.8751,
    y2: 44.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE909E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7953D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_655_1649",
    x1: 21.1696,
    y1: 7.81455,
    x2: 40.0136,
    y2: 43.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_655_1649",
    x1: 37.6287,
    y1: -0.98422,
    x2: 56.4748,
    y2: 34.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_655_1649",
    x1: 37.6504,
    y1: -0.994662,
    x2: 56.4965,
    y2: 34.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_655_1649",
    x1: 34.3397,
    y1: 0.775063,
    x2: 53.1859,
    y2: 36.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_655_1649",
    x1: 3.36747,
    y1: 17.3289,
    x2: 22.2136,
    y2: 52.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_655_1649",
    x1: 11.9201,
    y1: 12.758,
    x2: 30.7662,
    y2: 48.0149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_655_1649",
    x1: 5.05737,
    y1: 16.4254,
    x2: 23.9035,
    y2: 51.6845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_655_1649",
    x1: 7.45929,
    y1: 15.1414,
    x2: 26.3054,
    y2: 50.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_655_1649",
    x1: 12.5208,
    y1: 12.4362,
    x2: 31.3669,
    y2: 47.6952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_655_1649",
    x1: 11.3294,
    y1: 13.0734,
    x2: 30.1756,
    y2: 48.3303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_655_1649",
    x1: 17.2695,
    y1: 9.92291,
    x2: 36.1135,
    y2: 45.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ED8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 53,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6691d7838eb5dca6c9e290d2eefa23cb.svg";
export { ForwardRef as ReactComponent };